import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Tier } from '@ekorank/shared'

interface AuthUser {
  id: string
  email: string
  tier: Tier
  trialExpiresAt: number | null
}

interface AuthState {
  user: AuthUser | null
  token: string | null
  setAuth: (user: AuthUser, token: string) => void
  clearAuth: () => void
  isAuthenticated: () => boolean
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      token: null,

      setAuth: (user, token) => set({ user, token }),

      clearAuth: () => set({ user: null, token: null }),

      isAuthenticated: () => {
        const { user, token } = get()
        return user !== null && token !== null
      },
    }),
    {
      name: 'ekorank-auth',
      partialize: (state) => ({ user: state.user, token: state.token }),
    },
  ),
)
